module.exports = __webpack_public_path__ + "assets/img/lidian.27edab33.png";